<template>
    <div class="maintenance" prop-lid="prod">
        <div class="test-drive__form" v-if="!limitExceeded">
            <maintenance-steps v-if="readyToRenderForm">
                <router-view :slot="$route.name"/>
            </maintenance-steps>
            <step-preloader v-else/>

            <session-expired v-if="showExpirationMessage"
                             @startOver="changeOfSessions"/>
        </div>
        <limit-exceeded v-else/>
    </div>
</template>

<script>
    import { cookieHelper } from '../../cookieHelper'
    import { mapMutations } from 'vuex';
    import MaintenanceSteps from './MaintenanceSteps.vue'
    import SessionExpired from '../../components/SessionExpired.vue'
    import LimitExceeded from '../../components/LimitExceeded.vue'

    export default {
        name: 'Maintenance',


        data(){
            return {
                limitExceeded: false,
                readyToRenderForm: false,
                sessionIsExpired: false,
                showExpirationMessage: false
            }
        },


        computed: {
            unforeseenSessionExpiration() {
                return this.$store.state.maintenance.unforeseenSessionExpiration;
            },
            sessionId() {
                return this.$store.state.maintenance.sessionId;
            },
            sessionExpirationTime() {
                return this.$store.state.maintenance.sessionExpirationTime;
            },
            formIsClean() {
                return this.$route.name === 'MaintenanceVehicle';
            },
            expirationTime() {
                return this.$store.state.maintenanceLimit.expirationTime;
            },
            requestLimit() {
                return this.$store.state.maintenanceLimit.limit;
            }
        },


        watch: {
            sessionIsExpired() {
                if(this.sessionIsExpired) {
                    if(this.sessionExpirationTime >= Date.now() && !this.unforeseenSessionExpiration) {
                        this.sessionIsExpired = false;
                        this.setSessionTimer();
                    } else if(!this.formIsClean) {
                        this.showExpirationMessage = true;
                    } else {
                        this.initSession();
                    }
                } else {
                    this.showExpirationMessage = false;
                }
            },

            unforeseenSessionExpiration() {
                if(this.unforeseenSessionExpiration) {
                    this.sessionIsExpired = true;
                }
            },

            $route(currentRoute, previousRoute){
                if(previousRoute.name === 'MaintenanceFinish') {
                    this.$router.push({name: 'MaintenanceVehicle'});
                    this.initSession();
                }
            }
        },


        methods: {
            ...mapMutations(['clearMaintenanceForm']),

            goToFirstStep() {
                this.clearMaintenanceForm();
                this.$router.push({name: 'MaintenanceVehicle'});
            },

            getSessionId() {
                return this.$store.dispatch('setMaintenanceSessionId').then(() => {
                    this.sessionIsExpired = false;
                });
            },

            setSessionTimer() {
                this.readyToRenderForm = true;
                setTimeout(() => {
                    this.sessionIsExpired = true;
                }, this.sessionExpirationTime - Date.now());
            },

            initSession() {
                this.getSessionId().then(() => {
                    this.setSessionTimer();
                });
            },

            changeOfSessions() {
                this.initSession();
                this.goToFirstStep();
            },

            checkExcessLimit() {
                const now = Date.now()/1000;
                if (now > this.expirationTime) {
                    this.$store.dispatch('setMaintenanceLimit').then(() => {
                        cookieHelper.set('OSB_ORDERS_COUNTER', 0);
                    })
                } else {
                    const ordersCounter = cookieHelper.get('OSB_ORDERS_COUNTER');
                    if(ordersCounter >= this.requestLimit && this.requestLimit !== 0) {
                        this.limitExceeded = true;
                    }
                }
            }
        },


        created() {
            this.checkExcessLimit();
            if(this.sessionExpirationTime >= Date.now()) {
                this.setSessionTimer();
            } else if (this.$route.name !== 'MaintenanceFinish') {
                this.initSession();
            } else {
                this.$router.push({name: 'MaintenanceVehicle'});
            }
        },


        components: {
            MaintenanceSteps,
            SessionExpired,
            LimitExceeded
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/maintenance/Maintenance.vue